export enum BackupSidePanelTab {
  general = 'general',
  license = 'license',
  backupPlans = 'backup-plans',
  restorePlans = 'restore-plans',
  backupStorage = 'backup-storage'
}
